import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {IMeshCellNote, MeshCellNote} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellNote';
import {MeshLocation, MeshLocationKey} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshLocation';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DateTimeUtil} from '@mintdata-wsp/wsp/util/DateTimeUtil';
import {action} from 'mobx';

export class MeshCellNoteController
{
    public applyNote(ctx:IWSPMeshContext):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;
        const {noteTextRef, note} = noteState;

        const timestamp = DateTimeUtil.getNow();
        const username = rootState.userSession.currentUser.username;

        const noteClientRect:ClientRect = noteTextRef.getBoundingClientRect();

        const {width, height} = noteClientRect;

        note.updatedBy = username;
        note.updatedAt = timestamp;
        note.width = width;
        note.height = height;

        if( !note.createdAt )
        {
            note.createdBy = username;
            note.createdAt = timestamp;
        }

        // this._setProperty(ctx, MeshCellNoteProps.Title, noteState.note.title);
        // this._setProperty(ctx, MeshCellNoteProps.Text, noteState.note.text);
        //
        // if( !noteState.note.createdAt )
        // {
        //     this._setProperty(ctx, MeshCellNoteProps.CreatedBy, username);
        //     this._setProperty(ctx, MeshCellNoteProps.CreatedAt, timestamp);
        // }
        //
        // this._setProperty(ctx, MeshCellNoteProps.UpdatedBy, username);
        // this._setProperty(ctx, MeshCellNoteProps.UpdatedAt, timestamp);

        this._setNote(ctx, note);
    }

    public focusNoteControl(ctx:IWSPMeshContext):void
    {
        this._focusText(ctx);
    }

    public _focusText(ctx:IWSPMeshContext):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;
        const {noteTextRef} = noteState;

        if( noteTextRef )
            noteTextRef.focus();
    }

    public _focusTitle(ctx:IWSPMeshContext):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;
        const {noteTitleRef} = noteState;

        if( noteTitleRef )
            noteTitleRef.focus();
    }

    public removeNote(ctx:IWSPMeshContext, cellKey:MeshLocationKey):void
    {
        const {sheetSettingsCtrl, sheetId} = ctx;

        sheetSettingsCtrl.setCellNote(sheetId, cellKey, null);
    }

    public setNoteTextRef(ctx:IWSPMeshContext, noteTextRef:HTMLElement):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;

        noteState.noteTextRef = noteTextRef;
    }

    public setNoteTitleRef(ctx:IWSPMeshContext, noteTitleRef:HTMLElement):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;

        noteState.noteTitleRef = noteTitleRef;
    }

    public nextFieldByTab(ctx:IWSPMeshContext, element:Element):void
    {
        const {mesh} = controllers.ui.spreadsheets;
        const meshState = mesh.getState(ctx);
        const noteState = meshState.note;
        const {noteTitleRef, noteTextRef} = noteState;

        if( element === noteTitleRef )
            this._focusText(ctx);
        else if( element === noteTextRef )
            this._focusTitle(ctx);
    }

    @action
    private _setProperty<T extends keyof IMeshCellNote>(ctx:IWSPMeshContext, prop:T, value:IMeshCellNote[T]):void
    {
        const state = this._getState(ctx);
        if( !state ) return;

        const {sheetSettingsCtrl, sheetId} = ctx;
        const {meshState} = state;

        if( !meshState.note ) return;

        const {colIndex, rowIndex} = meshState.note;

        const cellKey = new MeshLocation(colIndex, rowIndex).asKey();

        let cellNote = sheetSettingsCtrl.getCellNote(sheetId, cellKey);

        if( !cellNote )
        {
            sheetSettingsCtrl.setCellNote(sheetId, cellKey, MeshCellNote.create());
            cellNote = sheetSettingsCtrl.getCellNote(sheetId, cellKey);
        }

        cellNote.setProperty(prop, value);
    }

    @action
    private _setNote(ctx:IWSPMeshContext, note:MeshCellNote):void
    {
        const state = this._getState(ctx);
        if( !state ) return;

        const {sheetSettingsCtrl, sheetId} = ctx;
        const {meshState} = state;

        if( !meshState.note ) return;

        const {colIndex, rowIndex} = meshState.note;

        const cellKey = new MeshLocation(colIndex, rowIndex).asKey();

        let cellNote = sheetSettingsCtrl.getCellNote(sheetId, cellKey);

        if( !cellNote )
            sheetSettingsCtrl.setCellNote(sheetId, cellKey, note);
        else
            cellNote.setNote(note);
    }

    private _getState(ctx:IWSPMeshContext):any
    {
        const {mesh} = commonControllers.spreadsheets;
        const {sheetSettingsCtrl, sheetId} = ctx;

        const meshState = mesh.getState(ctx);

        if( !meshState.details.selectedRange )
            return;

        const {
            details: {activeCell},
            size: {numCols, numRows}
        } = meshState;

        const activeCellNote = sheetSettingsCtrl.getCellNote(sheetId, activeCell.asKey());

        return {
            meshState,
            numCols,
            numRows,
            activeCellNote
        };
    }
}
